import { prefixedId } from '@mattrika/utils'
import { text, timestamp } from 'drizzle-orm/pg-core'

export const timestamps = {
    createdAt: timestamp({ withTimezone: true }).defaultNow(),
    updatedAt: timestamp({ withTimezone: true }).$onUpdate(() => new Date()),
}

export const id = (prefix: string) =>
    text()
        .primaryKey()
        .$defaultFn(() => prefixedId(prefix))
